import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage, useIntl } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteEffortRequestDialogProps = {
  open: boolean;
  effortIds: GridRowSelectionModel;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteEffortRequestDialog = ({
  open,
  effortIds,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteEffortRequestDialogProps) => {
  // other hooks
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    const postData = effortIds.map((effortId) => Number(effortId));

    try {
      setLoading(true);

      const response = await apiService.deleteEffortRequest(postData);

      if (response.isSuccess) {
        enqueueSnackbar(
          intl.formatMessage(
            {
              id: 'effortTracing.deleteEffortRequestCompleted',
              defaultMessage: '{count} adet seçili efor talebi silme işlemi başarıyla tamamlandı.',
            },
            { count: postData.length }
          ),
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      title={<FormattedMessage id="effortTracing.deleteEffortRequest" defaultMessage="Efor Talebi Sil" />}
      description={intl.formatMessage(
        {
          id: 'effortTracing.deleteEffortRequestRepeat',
          defaultMessage:
            'Bu işlem onaylandıktan sonra {count} adet efor talebi veritabanından silinecektir. Silme işlemini onaylıyor musunuz?',
        },
        { count: effortIds.length }
      )}
    />
  );
};

export default DeleteEffortRequestDialog;
